import React, { useEffect, useState } from 'react';
import '../static/table.css';
import '../static/popup.css';
import '../static/calender.scss';
import axios from 'axios';
import { Link } from 'react-router-dom';

const GroomingSchedule = () => {
  const [groomingData, setGroomingData] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [startOfWeek, setStartOfWeek] = useState(getMonday(new Date())); // Current week's Monday

  const handleClick = () => setShowPopup(true);
  const closePopup = () => setShowPopup(false);

  function getMonday(date) {
    const d = new Date(date);
    const day = d.getDay();
    const diff = d.getDate() - day + (day === 0 ? -6 : 1); // adjust when Sunday
    return new Date(d.setDate(diff));
  }

  function changeWeek(offset) {
    const newDate = new Date(startOfWeek);
    newDate.setDate(newDate.getDate() + offset * 7);
    setStartOfWeek(getMonday(newDate));
  }

  function getWeekDays(start) {
    const days = [];
    for (let i = 0; i < 7; i++) {
      const d = new Date(start);
      d.setDate(start.getDate() + i);
      days.push(d);
    }
    return days;
  }

  const weekDays = getWeekDays(startOfWeek);

  const formatDate = (date) => {
    return date.toISOString().split("T")[0]; // yyyy-mm-dd
  };

  // Fetch grooming data for the week
  useEffect(() => {
    const start = formatDate(weekDays[0]);
    const end = formatDate(weekDays[6]);

    axios
      .get(`/fetch-service/?service=grooming&date=${end}&beforedate=${start}`)
      .then((res) => {
        setGroomingData(res.data.grooming || []);
      })
      .catch((err) => console.error("Failed to fetch grooming data:", err));
  }, [startOfWeek]); // refetch on week change

  const hours = Array.from({ length: 13 }, (_, i) => 8 + i); // 8 to 20

  return (
    <>
      <div className="week-navigation">
        <button  className='button' onClick={() => changeWeek(-1)}>Previous Week</button>
        <button  className='button' style={{backgroundColor: 'red'}} onClick={() => changeWeek(1)}>Next Week</button>
      </div>
    <div className="calendar">

    

      <div className="days">
        {weekDays.map((dateObj, dayIndex) => {
          const dateStr = formatDate(dateObj);
          const dayName = dateObj.toLocaleDateString('en-US', { weekday: 'short' });

          const dayEvents = groomingData.filter(event => event.datee === dateStr);

          return (
            <div className="day"  key={dayIndex}>
              <div className="date" >
                <p className="date-num">{dateStr}</p>
                <p className="date-day">{dayName}</p>
              </div>

              {hours.map((hour) => {
                const eventsThisHour = dayEvents.filter(ev => parseInt(ev.hour.split(":")[0]) === hour);
                return (
                  <div
                    className={`events ${hour % 2 === 0 ? 'mon' : 'tues'}`}
                    style={{ backgroundColor: hour % 2 === 0 ? 'white' : '#f2d3d8' }}
                    key={hour} 
                  >
                    {eventsThisHour.map((item, idx) => (
                      <div key={idx}  className="event start-10 end-12 corp-fi">
                        
                        <p className="title">{item.petname}</p>
                        <p className="time">{item.ownername}</p>
                        <p className="time">{item.hour}</p>
                      </div>
                    ))}

                    {eventsThisHour.length === 0 && (
                      <div className="event start-1 end-4 ent-law">
                        <p className="title">{hour} -  {hour+1}</p>
                        <p className="title">Available</p>
                         
                        <Link to={`/add-appointment/${dateStr}/${hour}`}>
                          <button className="button">Appointment</button>
                        </Link>
                       </div>
                    )}
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>

      {showPopup && (
        <div className="popup">
          <div className="popup-inner">
            <Link to={`/add-appointment/`}><h2>Go Appointment Form</h2></Link>
            <button onClick={closePopup} className='button'>Close</button>
          </div>
        </div>
      )}
    </div>
    </>
  );
};

export default GroomingSchedule;
